export interface SmppConnectionState {
  smppConnections: SmppConnectionItem[]
  smppConnectionItem?: SmppConnectionItem
  serverNames: string[]
}

export interface SmppConnectionFilter {
  name?: string,
  description?: string,
}

export interface SmppConnectionItem {
  id?:number
  name: string,
  description: string,
  service_provider?:string,
  service_provider_id?:number,
  connects?: LogicaSmppConnect[]

  addConnects(serverNames:string[]):void
}

export interface LogicaSmppConnect {
  server_name: string,
  server_hostname: string,
  server_port: number,
  local_ip?: string,
  local_port?: number,
  system_id: string,
  password: string,
  addr_ton?: number,
  addr_npi?: number,
  default_source_ton?: number,
  default_source_npi?: number,
  default_destination_ton?: number,
  default_destination_npi?: number,
  system_type?: string,
  max_throughput?: string,
  window_size?: number,
}

export class SmppConnectionItemImpl implements SmppConnectionItem {
  description: string;
  name: string;
  connects: LogicaSmppConnect[];

  constructor() {
    this.description = "";
    this.name = "";
    this.connects = [];
  }

  addConnects(serverNames:string[]) {
    serverNames.forEach(value => this.connects.push(new LogicaSmppConnectImpl(value)))
  }
}

export class LogicaSmppConnectImpl implements LogicaSmppConnect {
  password: string;
  server_hostname: string;
  server_name: string;
  server_port: number;
  system_id: string;
  window_size?: number;

  constructor(server_name: string) {
    this.server_name = server_name;
    this.server_hostname = "";
    this.server_port = 0;
    this.system_id = "";
    this.password = "";
    this.window_size = 10;
  }
}
